import { z } from 'zod';

import { ProviderInterface } from '../providers';
import { ProductInterface } from '../products';

export const coreStockMovementPayloadSchema = z
    .object({
        PRODUCT_ID: z.number().int().nonnegative(),
        COUNT: z.number().int(),
        TYPE: z.enum(['stock_correction', 'order', 'return', 'receiving', 'completition', 'quality_hold', 'quality_release']),
        EXPIRATION_DATE: z.string().nullable().optional(),
        LOT: z.string().max(255).nullable().optional(),
    })
    .strict();

export type StockMovementCorePayload = z.infer<typeof coreStockMovementPayloadSchema>;
export type StockMovementCoreResponse = StockMovementCorePayload &
    Pick<ProductInterface, 'SKU'> &
    Pick<ProviderInterface, 'ESHOP_KEY'> & {
        ID: number;
        CREATED_AT: string;
        UPDATED_AT: string;
    };
